import IInterventionDocuments from 'models/InterventionDocuments';

import { ReduxStore } from 'store/types';

export interface IInterventionDocumentsSorted {
  invoice: IInterventionDocuments[];
  mandate: IInterventionDocuments[];
  photosDamage: IInterventionDocuments[];
  photosRepair: IInterventionDocuments[];
  report: IInterventionDocuments[];
}

function getDocuments(state: ReduxStore): IInterventionDocumentsSorted {
  return state.intervention.getDocuments.documents;
}

export default getDocuments;
